<div
  class="news-authorization-status-filter"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="isOpen = !isOpen"
>
  <input type="text" [placeholder]="labelText" readonly />
  <span matSuffix class="material-icons arrow-icons" *ngIf="!isOpen">
    expand_more
  </span>
  <span matSuffix class="material-icons arrow-icons" *ngIf="isOpen">
    expand_less
  </span>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    (overlayOutsideClick)="isOpen = false"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayHasBackdrop]="true"
    (detach)="isOpen = false"
    (backdropClick)="isOpen = false"
  >
    <app-select-simple-list
      class="custom-overlay"
      [hideSearchComponent]="true"
      [hidePhoto]="true"
      [list]="status"
      [selectAllText]="selectAllText"
      (selectEvent)="handleStatusSelect($event)"
    ></app-select-simple-list>
  </ng-template>
</div>
